export default {
    activeGroup: null,

    groups:[],
    scopedGroups:[]

}